import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { ScheduleModalMode } from '../../enums/schedule-model-mode.enum';
import { ScheduleSettingsComponent } from '../../../components/schedule-settings/schedule-settings.component';
import { Schedule } from '../../models/entities/schedule.type';

@Injectable()
export class ScheduleSettingsDialogService {
  constructor(private readonly dialog: MatDialog) {}

  public show(
    schedule: Schedule,
    scheduleModelMode: ScheduleModalMode = null
  ): Observable<void> {
    const dialogRef = this.dialog.open(ScheduleSettingsComponent, {
      width: '420px',
    });
    Object.assign(dialogRef.componentInstance, {
      schedule,
      scheduleModelMode,
    });

    return dialogRef.afterClosed();
  }
}
